const CONST = {
    'SET_CONFIG':'THEMES/SET_CONFIG',
    'SET_SELECTED_ITEM':'THEMES/SET_SELECTED_ITEM',
    'SET_PREVIEW_THEME':'THEMES/SET_PREVIEW_THEME',
    'SET_ACTIVE_THEME':'THEMES/SET_ACTIVE_THEME',
    'CLEAR_PREVIEW':'THEMES/CLEAR_PREVIEW',
    'FETCH_ITEM_SUCCESS':'THEMES/FETCH_ITEM_SUCCESS',
    'FETCH_ITEM_FAILED':'THEMES/FETCH_ITEM_FAILED',
    'FETCH_ITEMS_SUCCESS':'THEMES/FETCH_ITEMS_SUCCESS',
    'FETCH_ITEMS_FAILED':'THEMES/FETCH_ITEMS_FAILED',
    'ADD_ITEM_SUCCESS':'THEMES/ADD_ITEM_SUCCESS',
    'ADD_ITEM_FAILED':'THEMES/ADD_ITEM_FAILED',
    'UPDATE_ITEM_SUCCESS':'THEMES/UPDATE_ITEM_SUCCESS',
    'UPDATE_ITEM_FAILED':'THEMES/UPDATE_ITEM_FAILED',
    'DELETE_ITEM_SUCCESS':'THEMES/DELETE_ITEM_SUCCESS',
    'DELETE_ITEM_FAILED':'THEMES/DELETE_ITEM_SUCCESS',
}

export default CONST;